import React from 'react'

import { List, ListItem, ListItemText } from '@mui/material'
import { EditProjectAction, DeleteProjectAction } from '../..'
import { useResolveComponentData } from '../../../local/hooks'
import { get } from 'lodash'

/**
 * Project contextual menu.
 * @return {JSX.Element}
 */
export const ProjectMenu = () => {
  const { jsElementRef, jsComponentData } = useResolveComponentData({
    containerType: 'project',
    attributeNames: ['data-project-id'],
  })
  const projectId = get(jsComponentData, 'data-project-id', '8')

  return (
    <List ref={jsElementRef} dense disablePadding>
      <ListItem disablePadding>
        <ListItemText>
          <EditProjectAction projectId={projectId} />
        </ListItemText>
      </ListItem>
      <ListItem disablePadding>
        <ListItemText>
          <DeleteProjectAction projectId={projectId} />
        </ListItemText>
      </ListItem>
    </List>
  )
}
